window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Utilities ================*/
/**
* Responsive Script
* ------------------------------------------------------------------------------
* A file that contains scripts highly couple code to the Responsive utility.
*
* @namespace Responsive
*/

theme.Responsive = (function() {
  function Responsive() {

    _classCallCheck(this, Responsive);

    this.currentBreakpoint = Responsive.getCurrentBreakpoint();

    window.addEventListener('resize', function () {
      var newBreakpoint = Responsive.getCurrentBreakpoint();

      if (this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(new CustomEvent('breakpoint:changed', { detail: {
        previousBreakpoint: this.currentBreakpoint,
        currentBreakpoint: newBreakpoint
      } }));

      this.currentBreakpoint = newBreakpoint;
    });
  };

  Responsive.prototype.matchesBreakpoint = function(breakpoint) {
    switch (breakpoint) {
      case 'small':
      return window.matchMedia('screen and (max-width: 640px)').matches;

      case 'medium':
      return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

      case 'medium-up':
      return window.matchMedia('screen and (min-width: 641px)').matches;

      case 'medium-down':
      return window.matchMedia('screen and (max-width: 1007px)').matches;

      case 'large':
      return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

      case 'large-up':
      return window.matchMedia('screen and (min-width: 1008px)').matches;

      case 'desktop':
      return window.matchMedia('screen and (min-width: 1280px)').matches;

      case 'widescreen':
      return window.matchMedia('screen and (min-width: 1600px)').matches;
    }
  };

  Responsive.prototype.getCurrentBreakpoint = function() {
    if (window.matchMedia('screen and (max-width: 640px)').matches) {
      return 'small';
    }

    if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
      return 'medium';
    }

    if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
      return 'large';
    }

    if (window.matchMedia('screen and (min-width: 1280px)').matches) {
      return 'desktop';
    }
  };

  return Responsive;
})();

/**
* Carousels Script
* ------------------------------------------------------------------------------
* A file that contains scripts highly couple code to the Carousel utility.
*
* @namespace Carousels
*/

theme.Carousels = (function() {
  function Carousels(element) {

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Carousels);

    this.element = element;
    this.initialConfig = $(element).data('flickity-config');
    this.options = options;

    console.log(this.initialConfig);

    this._attachListeners();
    this._build();

  };

  Carousels.prototype.destroy = function() {
    this.flickityInstance.destroy();

    if (this.initialConfig['breakpoints'] !== undefined) {
      document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
    }
  };

  Carousels.prototype.selectCell = function(index) {
    var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (shouldPause) {
      this.flickityInstance.pausePlayer();
    }

    this.flickityInstance.select(index, false, !shouldAnimate);
  };

  Carousels.prototype.pausePlayer = function() {
    this.flickityInstance.pausePlayer();
  };

  Carousels.prototype.unpausePlayer = function() {
    this.flickityInstance.unpausePlayer();
  };

  Carousels.prototype.resize = function() {
    this.flickityInstance.resize();
  };

  Carousels.prototype.getSelectedIndex = function() {
    return this.flickityInstance.selectedIndex;
  };

  Carousels.prototype.getSelectedCell = function() {
    return this.flickityInstance.selectedCell.element;
  };

  Carousels.prototype._attachListeners = function() {
    if (this.initialConfig['breakpoints'] !== undefined) {
      this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
      document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
    }
  };

  /**
  * Create the carousel instance
  */

  Carousels.prototype._build = function() {
    var _this = this;

    var config = this._processConfig();

    this.flickityInstance = new Flickity(this.element, config);
    this._validateDraggable();

    this.selectedIndex = this.flickityInstance.selectedIndex;

    this.flickityInstance.on('resize', this._validateDraggable.bind(this));

    if (this.options['onSelect']) {
      this.flickityInstance.on('select', function () {
        // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
        // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)

        if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
          _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);
          _this.selectedIndex = _this.flickityInstance.selectedIndex;
        }
      });
    }

    if (this.options['onClick']) {
      this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
        _this.options['onClick'](cell, index);
      });
    }
  };

  /**
  * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
  * if the displayed elements equals to the amount of elements
  */

  Carousels.prototype._validateDraggable = function() {
    var isActive = this.flickityInstance.isActive || false;

    if (!isActive || !this.flickityInstance.options['draggable']) {
      return; // Not draggable, so nothing to do
    }

    if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
      this.flickityInstance.unbindDrag();
    } else {
      this.flickityInstance.bindDrag();
    }
  };

  /**
  * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
  */

  Carousels.prototype._processConfig = function() {
    var config = Object.assign({}, this.initialConfig);

    delete config['breakpoints'];

    if (this.initialConfig['breakpoints'] === undefined) {
      return config; // No change, we simply return the config as it is
    }

    var breakpoints = this.initialConfig['breakpoints'];

    breakpoints.forEach(function (breakpoint) {
      if (theme.Responsive.matchesBreakpoint(breakpoint['matches'])) {
        config = Object.assign(config, breakpoint['settings']);
      }
    });

    return config;
  };

  /**
  * Verify if the breakpoint has changed, and optionally update the carousel
  */

  Carousels.prototype._onBreakpointChanged = function() {
    // The breakpoint may have changed, so we delete the carousel and rebuild it
    this.flickityInstance.destroy();
    this._build();
  };

return Carousels;

})();

/**
 * Modals Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Modals utility.
 *
   * @namespace Modals
 */

 theme.Modals = (function() {
   function Modal(id, name, options) {
     var defaults = {
       close: '.js-modal-close',
       open: '.js-modal-open-' + name,
       openClass: 'modal--is-active',
       closingClass: 'modal--is-closing',
       bodyOpenClass: 'modal-is-open',
       bodyOpenSolidClass: 'modal-open--solid',
       bodyClosingClass: 'modal-closing',
       closeOffContentClick: true
     };

     this.id = id;
     this.$modal = $('#' + id);

     if (!this.$modal.length) {
       return false;
     }

     this.nodes = {
       $parent: $('html').add('body'),
       $modalContent: this.$modal.find('.modal__inner')
     };

     this.config = $.extend(defaults, options);
     this.modalIsOpen = false;
     this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
     this.isSolid = this.config.solid;

     this.init();
   }

   Modal.prototype.init = function() {
     var $openBtn = $(this.config.open);

     // Add aria controls
     $openBtn.attr('aria-expanded', 'false');

     $(this.config.open).on('click', this.open.bind(this));
     this.$modal.find(this.config.close).on('click', this.close.bind(this));

     // Close modal if a drawer is opened
     $('body').on('drawerOpen', function() {
       this.close();
     }.bind(this));
   };

   Modal.prototype.open = function(evt) {
     // Keep track if modal was opened from a click, or called by another function
     var externalCall = false;

     // don't open an opened modal
     if (this.modalIsOpen) {
       return;
     }

     // Prevent following href if link is clicked
     if (evt) {
       evt.preventDefault();
     } else {
       externalCall = true;
     }

     // Without this, the modal opens, the click event bubbles up to $nodes.page
     // which closes the modal.
     if (evt && evt.stopPropagation) {
       evt.stopPropagation();
       // save the source of the click, we'll focus to this on close
       this.$activeSource = $(evt.currentTarget);
     }

     if (this.modalIsOpen && !externalCall) {
       this.close();
     }

     this.$modal
       .prepareTransition()
       .addClass(this.config.openClass);
     this.nodes.$parent.addClass(this.config.bodyOpenClass);

     if (this.isSolid) {
       this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
     }

     this.modalIsOpen = true;


     if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
       this.$activeSource.attr('aria-expanded', 'true');
     }

     $('body').trigger('modalOpen.' + this.id);

     this.bindEvents();
   };

   Modal.prototype.close = function() {
     // don't close a closed modal
     if (!this.modalIsOpen) {
       return;
     }

     // deselect any focused form elements
     $(document.activeElement).trigger('blur');

     this.$modal
       .prepareTransition()
       .removeClass(this.config.openClass)
       .addClass(this.config.closingClass);
     this.nodes.$parent.removeClass(this.config.bodyOpenClass);
     this.nodes.$parent.addClass(this.config.bodyClosingClass);
     var o = this;
     window.setTimeout(function() {
       o.nodes.$parent.removeClass(o.config.bodyClosingClass);
       o.$modal.removeClass(o.config.closingClass);
     }, 500); // modal close css transition

     if (this.isSolid) {
       this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
     }

     this.modalIsOpen = false;


     if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
       this.$activeSource.attr('aria-expanded', 'false').focus();
     }

     $('body').trigger('modalClose.' + this.id);

     this.unbindEvents();
   };

   Modal.prototype.bindEvents = function() {
     // Pressing escape closes modal
     this.nodes.$parent.on('keyup.modal', function(evt) {
       if (evt.keyCode === 27) {
         this.close();
       }
     }.bind(this));

     if (this.config.closeOffContentClick) {
       // Clicking outside of the modal content also closes it
       this.$modal.on('click.modal', this.close.bind(this));

       // Exception to above: clicking anywhere on the modal content will NOT close it
       this.nodes.$modalContent.on('click.modal', function(evt) {
         evt.stopImmediatePropagation();
       });
     }
   };

   Modal.prototype.unbindEvents = function() {
     this.nodes.$parent.off('.modal');

     if (this.config.closeOffContentClick) {
       this.$modal.off('.modal');
       this.nodes.$modalContent.off('.modal');
     }
   };

   return Modal;
 })();

'use strict';
/* ===================================================================================== @preserve =
___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
|\
|/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */




var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
  pagination: Selector of pagination container
  container: Selector of repeating content
  offset: 0, offset the number of pixels before the bottom to start loading more on scroll
  loadingText: 'Loading', The text changed during loading
  callback: null, function to callback after a new page is loaded
  */
  var current = 0;
  var self = this;
  $(document).ready(function() {

    $('.ProductItem__Wrapper').click(function(){
      $.cookie('scrollPosition', $(window).scrollTop());
    });

    var page = location.hash.substring(location.hash.indexOf('#')+1,location.hash.length)
    self.request = new XMLHttpRequest();
    var end = 0;


    self.requestOnce = function(i) {
      if (i < parseInt(page)) {
        self.request.open('GET', location.href.replace(location.hash,"?page="+(i+1)));
        self.request.responseType = 'document';
        self.request.send();
        current = i;
        if (i === parseInt(page)-1) {
          end = i;
          $(window).scrollTop(parseInt($.cookie('scrollPosition')));
        }
      }
    }


    var try1 = function(i){
      if (i === parseInt(page)-1) {
        end = i;
      }
      if (i<parseInt(page)) {


        var x = i+1;
        setTimeout(function(){
          var request = new XMLHttpRequest();
          request.onreadystatechange = function success() {
            if (request.readyState === 4 && request.status === 200) {
              var newContainer = request.responseXML.querySelectorAll(self.settings.container)[0];
              var newPagination = request.responseXML.querySelectorAll(self.settings.pagination)[0];
              self.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
              self.paginationElement.innerHTML = newPagination.innerHTML;

              if (self.settings.callback && typeof self.settings.callback === 'function') {
                self.settings.callback(self.request.responseXML);
              }

              var showing = Math.min(page * this.perPage, this.total);
              var percentage = (showing / this.total) * 100;

              this.progressElement.style.width = percentage + '%';
              this.showingElement.innerHTML = showing;

              self.initialize();

              if (end !== 0) {
                setTimeout(function(){
                  if (parseInt($.cookie('scrollPosition')) > 10000) {
                    $(window).scrollTop(parseInt($.cookie('scrollPosition')));
                  } else {
                    $(window).scrollTop(parseInt($.cookie('scrollPosition')));
                  }

                }, 100);


              }
              $('.ProductItem__Wrapper').click(function(){

                $.cookie('scrollPosition', $(window).scrollTop());
              });
              //self.requestOnce(current+1);

            }

            //window.scrollTo(0,document.body.scrollHeight);



          }.bind(self)
          request.open('GET', location.href.replace(location.hash,"?page="+x));
          request.responseType = 'document';
          request.send();
          try1(i+1);
        }, i*300);

      }
    }
    try1(1);

    //self.requestOnce(1);


  });


  var defaultSettings = {
    method: 'scroll',
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    showing: '#AjaxinateShowing',
    total: '#AjaxinateTotal',
    progress: '#AjaxinateProgress',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  }; // Merge configs

  this.settings = Object.assign(defaultSettings, settings);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.showingElement = document.querySelector(this.settings.showing);
  this.totalElement = document.querySelector(this.settings.total);
  this.progressElement = document.querySelector(this.settings.progress);
  this.perPage = this.paginationElement.dataset.paginatePer;
  this.total = this.paginationElement.dataset.paginateTotal;

  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;

    if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();

  if (this.clickActive) {
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {

  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();

  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;

      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }

      this.initialize();

      var link = this.nextPageUrl;
      var page = link.substring(link.indexOf('page=')+5,link.length);
      var showing = Math.min(page * this.perPage, this.total);
      var percentage = (showing / this.total) * 100;

      this.progressElement.style.width = percentage + '%';
      this.showingElement.innerHTML = showing;

      function replaceQueryParam(param, newval, search) {
        var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
        var query = search.replace(regex, "$1").replace(/&$/, '');

        return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
      }

      window.location = window.location.pathname +'#'+ page
      //    window.scrollTo(0,document.body.scrollHeight);

      $('.ProductItem__Wrapper').click(function(){
        $.cookie('scrollPosition', $(window).scrollTop());
      });

    }
  }.bind(this);



  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};


/*================ Sections ================*/
/**
 * Shop Switch Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Shop Switch module.
 *
   * @namespace ShopSwitch
 */

 theme.ShopSwitch = (function() {

   function ShopSwitch(container) {
     var $container = this.$container = $(container);
     var sectionId = $container.attr('data-section-id');
     this.cookieName = $container.data('cookie-name');

     if (!$container.length) {
       return;
     }

     this.data = {
       secondsBeforeShow: $container.data('delay-seconds'),
       daysBeforeReappear: $container.data('delay-days'),
       cookie: $.cookie(this.cookieName),
       testMode: $container.data('test-mode'),
       sortCountries: $container.data('sort-countries'),
       mode: $container.data('mode'),
       blockType: $container.data('block-type'),
       switcherEnable: $container.data('switcher-enable'),
       switcherTemplate: $container.data('switcher-template'),
       countryTemplate: $container.data('country-template'),
       socialReferrer: (document.referrer.includes('facebook.com/') || document.referrer.includes('instagram.com/') || document.referrer.includes('snapppt.com/')),
       isBot: /bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(navigator.userAgent),
       apiUrl: "https://api.ipstack.com/check?access_key=3b3ccc2d81b7e0c08b70aa8a949de94a"
     };

     if($container.data('countries').length) {
       try {
         this.data.countries = JSON.parse($container.data('countries'));
       } catch(e) {
         this.data.countries = [];
         console.error('[Shop Switch] There was an error reading the countries.');
       }
     }

     this.data.currentCountry = _.find(this.data.countries, function(o) { return o.current }) || {};

     this.modal = new theme.Modals('ShopSwitch-' + sectionId, 'storeswitcher-popup-modal');

     // Make openPopup available on window
     window.openshopswitch = (function() {
       this.openPopup();
     }).bind(this);

     if (window.top.location.search.indexOf('switch') !== -1) {
       this.setCookie();
       this.data.cookie = this.data.currentCountry.domain;
     }

     console.info('%c[Shop Switch] ' + '%cCookie: ' + this.data.cookie, 'color: blue;', 'color: black;');

     if (!this.data.isBot) {

        if (this.data.cookie != this.data.currentCountry.domain || this.data.socialReferrer || this.data.testMode) {

          $.getJSON( this.data.apiUrl, (function( json ) {
            this.handleLocation( json.country_code );
          }).bind(this))
          .fail(function(jqXHR, textStatus, errorThrown) {
            console.log('ipstack request failed: ' + textStatus);
          });

        }
     }

     $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));

     // Check if the switcher is enabled
     if (this.data.switcherEnable) {
       // Build dropdown
       var context = {
         currentTitle: this.data.currentCountry.title,
         currentImg: this.data.currentCountry.img,
         currentCurrency: this.data.currentCountry.currency,
         countries: _.sortBy(this.data.countries, [function(o) { return !o.current; }])
       };

       var template = Mustache.render(this.data.switcherTemplate, context);

       // Add final dropdown html to wrappers
       $('.shop-switch__switcher').each(function() {
         $(this).html(template);
       })

     }

     if (this.data.blockType == 'regions') {

       _.each(this.data.countries, (function(country) {

         // Build country
         var context = {
           country: country
         };

         var template = Mustache.render(this.data.countryTemplate, context);

         // Add final dropdown html to wrappers
         $('.shop-switch__continent[data-continent=' + country.continent_code + '] .continent__countries').append(template);

         $('.shop-switch__continent[data-continent=' + country.continent_code + ']').removeClass('continent--empty');

       }).bind(this));

       if (this.data.sortCountries) {
         $('.shop-switch__continent .continent__countries').each(function() {
           var continent = $(this).data('continent');
           var ordered = $(this).find('.shop-switch__country').sort(function(a, b) {
             return String.prototype.localeCompare.call($(a).data('country').toLowerCase(), $(b).data('country').toLowerCase());
           });
           $(this).empty();
           ordered.appendTo(this);
         })
       }

     }

     window.ShopSwitch = this;

   }

   ShopSwitch.prototype = $.extend({}, ShopSwitch.prototype, {

     handleLocation : function(locationData) {

       if (_.isUndefined(locationData)) {
         if(this.data.testMode) console.error('Could not get location based on IP.');
         return;
       }

       var ipCountryCode = locationData;
       if(this.data.testMode) console.log('[Shop Switch] Your location: ' + ipCountryCode);

       // Check if the desired country is available by index
       var ip_index = _.findIndex(this.data.countries, function(o) { return o.country_code == ipCountryCode; }),
           default_index = _.findIndex(this.data.countries, function(o) { return o.default; }),
           current_index = _.findIndex(this.data.countries, function(o) { return o.current; });

       // Only get domain for IP if a dedicated store exists
       if (ip_index >= 0) var ip_domain = this.data.countries[ip_index].domain;
       var default_domain = this.data.countries[default_index].domain,
           current_domain = this.data.countries[current_index].domain;

       // Is country from IP in our list AND is that the current shop?
       if (!_.isUndefined(ip_domain) && current_domain == ip_domain) {
         // Do nothing
       }
       // Is country from IP NOT in our list AND are we on the default shop?
       else if (_.isUndefined(ip_domain) && current_domain == default_domain) {
         // Do nothing
       } else {
         // Is country from IP in our list?
         if (!_.isUndefined(ip_domain)) {
           var new_domain = ip_domain;
         }
         // Go to default
         else {
           var new_domain = default_domain;
         }

         if(this.data.testMode) console.info('[Shop Switch] Designated shop: ' + new_domain);

         // Show the modal content for the designated country
         if (this.data.blockType == 'stores') {
           $('#' + this.data.countries[_.findIndex(this.data.countries, function(o) { return o.domain == new_domain})].id).show();
         }

         // Open the modal
         if (this.data.mode == 'enabled' || this.data.testMode) {
           this.initPopupDelay();
         } else if(this.data.mode == 'redirect') {
           if(this.data.testMode) console.log('[Shop Switch] Redirecting...');
           if (window.location.search.indexOf('design_theme_id') !== -1) {
             // Warn if redirect inside theme editor
             if(this.data.testMode) console.warn('[Shop Switch] Cannot redirect from Theme Editor.\nWould have redirected to: ' + this.data.countries[new_index].url);
           } else {
             var new_index = _.findIndex(this.data.countries, function(o) {
               return o.domain == new_domain;
             });

             this.redirect(this.data.countries[new_index].url);
           }
         }
       }

     },

     initPopupDelay: function() {

       setTimeout(function() {
         this.modal.open();
       }.bind(this), this.data.secondsBeforeShow * 1000);

     },

     redirect: function(url) {
       window.top.location.replace(url);
     },

     openPopup: function() {
       this.modal.open();
     },

     closePopup: function() {
       // Remove a cookie in case it was set in test mode

       if (this.data.testMode) {
         $.removeCookie(this.cookieName, { path: '/' });
         return;
       }

       this.setCookie();
     },

     setCookie: function() {
       $.cookie(this.cookieName, this.data.currentCountry.domain, { path: '/', expires: this.data.daysBeforeReappear });
     },

     onLoad: function() {
       this.modal.open();
       console.log('load');
     },

     onSelect: function() {
       this.modal.open();
       console.log('select');
     },

     onDeselect: function() {
       this.modal.close();
     },

     onBlockSelect: function(event) {
       if (!this.modal.modalIsOpen) {
         this.modal.open();
       }
       $(event.target).show();
     },

     onBlockDeselect: function(event) {
       $(event.target).hide();
     },

     onUnload: function() {}
   });

   return ShopSwitch;
 })();

/**
 * Variant Collection
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled code to the Wear-it-with module.
 *
 * @namespace WearItWith
 */

theme.WearItWith = (function() {

  function WearItWith(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    if (!$container.length) {
      return;
    }

    this.data = {
      carouselElement: $($container).find('.wear-it-with__carousel')[0]
    };

    if (this.data.carouselElement != undefined) {
      this.carousel = new theme.Carousels(this.data.carouselElement);
    }

  }

  WearItWith.prototype = $.extend({}, WearItWith.prototype, {
    onUnload: function() {
      this.$container.off(this.settings.eventNamespace);
    }
  });

  return WearItWith;

})();

/**
 * Shop Switch Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Shop Switch module.
 *
   * @namespace CookieBanner
 */

 theme.CookieBanner = (function() {

   function CookieBanner(container) {
     var $container = this.$container = $(container);
     var sectionId = $container.attr('data-section-id');
     this.cookieName = $container.data('cookie-name');

     if (!$container.length) {
       return;
     }

     this.elements = {
       declineButton: $container.find('#cookieDecline'),
       cookieFunctions: $container.find('#cookieFunctions'),
       cookieBannerInner: $container.find('#cookieBannerInner'),
       readMoreButton: $container.find('#cookieReadMore')
     }

     this.data = {
       secondsBeforeShow: $container.data('delay-seconds'),
       daysBeforeReappear: $container.data('delay-days'),
       cookie: $.cookie(this.cookieName),
       testMode: $container.data('test-mode'),
       mode: $container.data('mode')
     };

     this.modal = new theme.Modals('CookieBanner-' + sectionId, 'cookiebanner-popup-modal', {
       bodyOpenClass: 'modal-open--scrollable'
     });

     this.elements.declineButton.on('click', (event) => {
       this.handleCookieDecline();
     });

     this.elements.readMoreButton.on('click', (event) => {
       this.elements.cookieBannerInner.toggleClass('expanded');
       this.elements.cookieFunctions.toggleClass('open');
     });

     console.info('%c[Cookie Banner] ' + '%cCookie: ' + this.data.cookie, 'color: blue;', 'color: black;');

     $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));

     // Open the modal
     if (this.data.mode == 'enabled' || this.data.testMode) {
       if (_.isUndefined(this.data.cookie) || this.data.testMode) {
         this.initPopupDelay();
       }
     }

     window.CookieBanner = this;

   }

   CookieBanner.prototype = $.extend({}, CookieBanner.prototype, {

     initPopupDelay: function() {

       setTimeout(function() {
         this.openPopup();
       }.bind(this), this.data.secondsBeforeShow * 1000);

     },

     openPopup: function() {
       this.modal.nodes.$modalContent = this.$container.find('.cookie-banner-bar');
       this.modal.open();
     },

     openPopup: function() {
       this.modal.nodes.$modalContent = this.$container.find('.cookie-banner-bar');
       this.modal.open();
     },

     handleCookieDecline: function() {
       this.closePopup();
       if (confirm("Du kan ikke bruge vores website uden cookies. Er du sikker?")) {
         this.elements.cookieBannerInner.addClass('expanded');
         this.elements.cookieFunctions.addClass('open');
         this.elements.declineButton.prop('disabled', true);
       } else {
         this.openPopup();
       }
     },

     closePopup: function() {
       // Remove a cookie in case it was set in test mode

       this.elements.cookieBannerInner.removeClass('expanded');
       this.elements.cookieFunctions.removeClass('open');
       this.elements.declineButton.prop('disabled', false);

       if (this.data.testMode) {
         $.removeCookie(this.cookieName, { path: '/' });
         return;
       }

       this.setCookie();
     },

     setCookie: function() {
       $.cookie(this.cookieName, true, { path: '/', expires: this.data.daysBeforeReappear });
     },

     onLoad: function() {
       this.openPopup();
       console.log('load');
     },

     onSelect: function() {
       this.openPopup();
       console.log('select');
     },

     onDeselect: function() {
       this.modal.close();
     },

     onBlockSelect: function(event) {
       if (!this.modal.modalIsOpen) {
         this.openPopup();
       }
       $(event.target).show();
     },

     onBlockDeselect: function(event) {
       $(event.target).hide();
     },

     onUnload: function() {}
   });

   return CookieBanner;
 })();

/**
 * QuickBuy Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Shop Switch module.
 *
   * @namespace QuickBuy
 */
 var function_count = 0;
 theme.QuickBuy = (function() {
   function QuickBuy(container) {

     var $container = this.$container = $(container);
     var sectionId = $container.attr('data-section-id');

     if (!$container.length) {
       return;
     }

     this.elements = {
       modal: $container.find('.modal__inner'),
       modalInner: $container.find('.modal__content')
     };

     this.modal = new theme.Modals(sectionId, 'quickbuy-popup');

     this.arrayOfProducts = $('[data-action="add-to-cart"]');

     // Public function for easy "onclick" HTML implementation
     window.openQuickBuy = this.loadProduct.bind(this);

     $('body').on('modalClose.' + $container.attr('id'),() => this.closePopup());

     document.addEventListener('cart:adding', this.closePopup.bind(this));

     window.QuickBuy = this;
   }

   QuickBuy.prototype = $.extend({}, QuickBuy.prototype, {

     loadProduct: function(url) {
       if (url.includes('?drawer')) {
         function_count = 0;
           $('body').on('modalClose.' + this.$container.attr('id'),() => this.reopenDrawer());
       }
       // Some links already has params on them. We clean the URL before using it
       if (url.includes('?')) {
         url = url.split('?')[0];
       }

       // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
        return fetch(url + '?view=ajax&timestamp=' + Date.now(), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(content => {
          content.text().then(html => {
            var sections = new slate.Sections();
            this.elements.modalInner.html(html);
            sections.register('product-quickbuy', window.ProductSectionConstructor);
            this.openPopup();
            window.dispatchEvent(new Event('resize'));
          });
        });
     },

     openPopup: function() {
       this.modal.open();
     },

     closePopup: function() {
       // Remove a cookie in case it was set in test mode
       this.modal.close();
     },

    reopenDrawer: function() {

        if(function_count === 0){
            $('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')[0].click();
            function_count = 1;
        }

    },

     onLoad: function() {
       this.openPopup();
     },

     onSelect: function() {
       this.openPopup();
     },

     onDeselect: function() {
       this.modal.close();
     },

     onBlockSelect: function(event) {
       if (!this.modal.modalIsOpen) {
         this.openPopup();
       }
       $(event.target).show();
     },

     onBlockDeselect: function(event) {
       $(event.target).hide();
     },

     onUnload: function() {}
   });

   return QuickBuy;
 })();


/*================ Sections ================*/
/**
 * TEMP
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Store Locator.
 *
 * @namespace StoreLocator
 */

theme.StoreLocator = function(options) {

  /*************** Variables ***************/

  var config = {
    "filterCountryEl": $('#filterCountry'),
    "filterOnlineEl": $('#filterOnline'),
    "filterPhysicalEl": $('#filterPhysical'),
    "filterTextEl": $('#filterInput'),
    "filterWrapEl": $('.stores__filter-wrap'),
    "filterAddressEl": $('#addressInput'),
    "filterRadiusEl": $('#filterRadius'),
    "filterLocationEl": $('#filterLocation'),
    "filterNoResultsEl": $('#filterNoResults'),
    "filterInvalidAddressEl": $('#filterInvalidAddress'),
    "storeEls": $('.store-item'),
    "resultCountEl": $('.stores__result-count'),
    "resultCountSingle": $('.stores__result-count').data('single'),
    "resultCountPlural": $('.stores__result-count').data('plural'),
    "storeGridClass": '.store-grid',
    "storeCountryClass": '.stores__country',
    "brandStoresClass": '.stores__brand-stores',
    "brandStoreClass": '.brand-store',
    "sectionByCountry": options.sectionByCountry,
    "mapId": "storesMap",
    "mapWrapClass": ".stores__map",
    "apiUrl": options.ipAccessKey ? 'https://api.ipstack.com/check?access_key=' + options.ipAccessKey : undefined
  };

  var allLocations = [];

  // setting the the filter function based on filter type option
  const filter = (options.filterType === 'country') ? countryFilter : textFilter;

  // If map or location based search is enabled, it's important that we only use
  // locations that has coordinates.
  if (options.inputType == 'blocks') {
    if (options.enableMap) {
      allLocations = _.remove(options.storeJSON, function(n) {
        return !(isNaN(n.lat) || isNaN(n.lng));
      });
    } else {
      allLocations = options.storeJSON;
    }

    filter();
  } else {
    if (options.csvPath != '') {

      Papa.parse(options.csvPath, {
        download: true,
      	quoteChar: '"',
      	delimiter: options.csvDelimiter,
        skipemptylines: true,
        header: true,
        complete: function(results, file) {

          var mappedJSON = _.map(results.data, function(obj) {

            var mappedObj = {
              "title":  obj[options.csvFieldCompany],
              "addressStreet": obj[options.csvFieldAddress],
              "addressPostalCode":  obj[options.csvFieldPostalCode],
              "addressLocality":  obj[options.csvFieldCity],
              "addressRegion":  obj[options.csvFieldRegion],
              "addressCountry": obj[options.csvFieldCountry],
              "addressString": createNiceAddress(obj),
              "phone": obj[options.csvFieldPhone],
              "email": obj[options.csvFieldEmail],
              "lat": parseFloat(obj[options.csvFieldLatitude]),
              "lng": parseFloat(obj[options.csvFieldLongitude]),
              "url": obj[options.csvFieldWebsite],
              "niceUrl": createNiceURL(obj[options.csvFieldWebsite]),
              "webshop": !!(obj['Webshop']),
              "noWebshop": !(obj['Webshop']), // because mustache.js doesn't do negative evaluation
              "physical": !!(obj['Store']),
              "_search": obj[options.csvFieldCompany].toLowerCase() + ' ' + createNiceAddress(obj).toLowerCase()
            }

            return mappedObj;

          });

          var filteredJSON = _.filter(mappedJSON, function(obj) {
            return !_.isUndefined(obj.addressCountry);
          });

          allLocations = filteredJSON;

          if (options.enableAutoFilterLocation) {
            $(config.filterLocationEl).click();
          } else {
            filter(filteredJSON);
          }

        }
      });
    }
  }


  /**
  * Inititate slider for brand stores
  **/
  if ($(config.brandStoreClass).length > 1) {
    $(config.brandStoresClass).slick({
      adaptiveHeight: true,
      arrows: false,
      dots: true
    });
  }

  if (options.enableIpLookup) {
    if (typeof window.ipLookup != 'undefined') {
      changeCountry(window.ipLookup.country_code);
      $(config.filterWrapEl).removeClass('loading_location');
    } else {
      if (config.apiUrl != undefined) {
        console.log(config.apiUrl);
        $.getJSON( config.apiUrl, (function( json ) {
          window.ipLookup = json;
          console.log(json);
          changeCountry(json.country_code);
          $(config.filterWrapEl).removeClass('loading_location');
        }).bind(this))
        .fail(function(jqXHR, textStatus, errorThrown) {
          console.log('ipstack request failed: ' + textStatus);
        });
      }

    }
  }

  /**
  * Filters an array of locations based on text input
  **/
  function textFilter(data) {

    $(config.storeGridClass).empty();
    $(config.storeCountryClass).hide();

    function filter(items, text, online, physical) {
      var textFiltered = find(items, text);
      return checkboxFilter(textFiltered, online, physical);
    }

    function checkboxFilter(items, online, physical) {
      if (online == physical) {
        return items;
      }
      return items.filter(function(item) {
        return (item.webshop && online) || (item.physical && physical);
      });
    }

    function find(items, text) {
      text = text || '';
      text = text.toLowerCase().split(' ');
      return items.filter(function (item) {
        return text.every(function (el) {
          return item._search.indexOf(el) > -1;
        });
      });
    }

    var filterText = config.filterTextEl.val(),
    filterOnline = config.filterOnlineEl.is( ":checked" ),
    filterPhysical = config.filterPhysicalEl.is( ":checked" );

    var items = data || allLocations;

    var filteredArray = filter(items, filterText, filterOnline, filterPhysical);

    $(config.storeGridClass).toggleClass('filtered', filteredArray.length != items.length);

    createListOfLocations(filteredArray);

    if (options.enableMap) {
      createSearchableMap(filteredArray.length ? filteredArray : items);
    }

  }

  /**
  * Filters an array of locations based on country
  **/
  function countryFilter(data) {

    $(config.storeGridClass).empty();
    $(config.storeCountryClass).hide();
    $(config.resultCountEl).toggle(typeof $(config.filterCountryEl).val() == 'string');

    function filter(items, country, online, physical) {
      var textFiltered = find(items, country);
      return checkboxFilter(textFiltered, online, physical);
    }

    function checkboxFilter(items, online, physical) {
      if (online == physical) {
        return items;
      }
      return items.filter(function(item) {
        return (item.webshop && online) || (item.physical && physical);
      });
    }

    function find(items, country) {
      return items.filter(function (item) {
        return item.addressCountry == country;
      });
    }

    var country = config.filterCountryEl.val(),
    filterOnline = config.filterOnlineEl.is( ":checked" ),
    filterPhysical = config.filterPhysicalEl.is( ":checked" );

    var items = data || allLocations;

    var filteredArray = filter(items, country, filterOnline, filterPhysical);

    $(config.storeGridClass).toggleClass('filtered', filteredArray.length != items.length);

    createListOfLocations(filteredArray);

  }

  /**
  * Change the chosen country in the select element
  *
  * @param {String} country
  *
  **/
  function changeCountry(country) {
    $(config.filterCountryEl).val(country).change();
  }


  /**
  * Creates a nice address string based on fields
  *
  * @param {Object}
  *
  **/
  function createNiceAddress(obj) {
    var str = [];

    if (!_.isUndefined(obj)) {

      if (obj[options.csvFieldAddress]) {
        str.push(obj[options.csvFieldAddress])
      }

      if (obj[options.csvFieldPostalCode]) {
        str.push(obj[options.csvFieldPostalCode])
      }

      if (obj[options.csvFieldCity]) {
        str.push(obj[options.csvFieldCity])
      }

      if (obj[options.csvFieldRegion]) {
        str.push(obj[options.csvFieldRegion])
      }

      return str.join(' ');

    } else {
      return '';
    }
  }

  /**
  * Creates a nice web address string based on URL
  *
  * @param {String}
  *
  **/
  function createNiceURL(url) {
    var str = '';

    if (!_.isUndefined(url)) {

      var str = url.replace(/http:\/\//g,'').replace(/https:\/\//g,'');

      return str;

    } else {
      return '';
    }
  }

  /**
  * Creates a nice web address string based on URL
  *
  * @param {Object}
  *
  **/
  function createStoreCard(store) {
    var template = options.storeTemplate;
    Mustache.parse(template);   // optional, speeds up future uses
    var rendered = Mustache.to_html(template, store);

    return rendered;
  }

  /**
  * Creates a map based on array of locations
  *
  * @param {Array} locations (optional)
  *
  **/
  function createSearchableMap(locations = allLocations) {

    var map;
    var bounds = new google.maps.LatLngBounds();
    var mapOptions = {mapTypeId: 'roadmap'};
    var markers = [];
    var infoWindowContent = [];

    if (options.mapStylesJSON) {
      mapOptions.styles = options.mapStylesJSON;
    }

    if (!options.enableUI) {
      mapOptions.disableDefaultUI = true;
    }

    var map = new google.maps.Map(document.getElementById(config.mapId), mapOptions);
    map.setTilt(45);

    locations.forEach(function(location) {
      if (location.lat != '' && location.lat != '') {
        markers.push([location.title, location.lat, location.lng]);

        infoWindowContent.push(['<div class="infoWindow"><h3>' + location.title +
        '</h3><p>' + location.addressString + '</p></div>']);
      }

    });

    var infoWindow = new google.maps.InfoWindow(), marker, i;

    // Place the markers on the map
    for (i = 0; i < markers.length; i++) {
      var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
      bounds.extend(position);
      marker = new google.maps.Marker({
        position: position,
        map: map,
        title: markers[i][0],
        icon: options.mapMarkerImage
      });

      // Add an infoWindow to each marker, and create a closure so that the current
      // marker is always associated with the correct click event listener
      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          infoWindow.setContent(infoWindowContent[i][0]);
          infoWindow.open(map, marker);
        }
      })(marker, i));

      // Only use the bounds to zoom the map if there is more than 1 location shown
      if (locations.length > 1) {
        map.fitBounds(bounds);
      } else {
        var center = new google.maps.LatLng(locations[0].lat, locations[0].lng);
        map.setCenter(center);
        map.setZoom(15);
      }
    }
  }

  /**
  * Filters array of locations based on distance from coordinates.
  * By default coordinates are looked up based on address input.
  *
  * @param {String} lat The latitude (optional)
  * @param {String} lng The longitude (optional)
  *
  **/
  function geoFilter(lat, lng) {
    var userLatLng;
    var geocoder = new google.maps.Geocoder();
    var userAddress = $(config.filterAddressEl).val().replace(/[^a-z0-9\s]/gi, '');
    var maxRadius = parseInt($(config.filterRadiusEl).val(), 10);

    if (userAddress == '' && typeof lat == 'undefined' && typeof lng == 'undefined') {

      if (options.enableMap) {
        createSearchableMap(allLocations);
      }

      createListOfLocations(allLocations);
      return;
    }

    if (typeof lat !== 'undefined' && typeof lng !== 'undefined' && maxRadius) {

      handleLatLngFilter(lat, lng);

    } else if(userAddress && maxRadius) {

      userLatLng = getLatLngViaHttpRequest(userAddress);

      function getLatLngViaHttpRequest(address) {
        // Set up a request to the Geocoding API
        // Supported address format is City, City + State, just a street address, or any combo
        var addressStripped = address.split(' ').join('+');
        var key = options.gmapsAPI;
        var request = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + addressStripped + '&key=' + key;

        // Call the Geocoding API using jQuery GET, passing in the request and a callback function
        // which takes one argument "data" containing the response
        $.get( request, function( data ) {

          // Abort if there is no response for the address data
          if (data.status === "ZERO_RESULTS") {
            console.log('Address not valid');
            $(config.filterInvalidAddressEl).show();
            return;
          }

          $(config.filterInvalidAddressEl).hide();

          handleLatLngFilter(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng);

        });
      }
    }

    /**
    * Filters array of locations based on distance from coordinates.
    *
    * @param {String} lat The latitude (optional)
    * @param {String} lng The longitude (optional)
    *
    **/
    function handleLatLngFilter(lat, lng) {
      var userLatLng = new google.maps.LatLng(lat, lng);
      var filteredLocations = allLocations.filter(isWithinRadius);

      if (filteredLocations.length > 0) {
        $(config.filterNoResultsEl).hide();

        if (options.enableMap) {
          createSearchableMap(filteredLocations);
        }

        createListOfLocations(filteredLocations);
      } else {
        $(config.filterNoResultsEl).show();
      }

      function isWithinRadius(location) {
        var locationLatLng = new google.maps.LatLng(location.lat, location.lng);
        var distanceBetween = google.maps.geometry.spherical.computeDistanceBetween(locationLatLng, userLatLng);

        return convertMetersToKilometers(distanceBetween) <= maxRadius;
      }
    }
  }

  function convertMetersToKilometers(meters) {
    return (meters * 0.001);
  }


  // Create/update list of stores based on array
  function createListOfLocations(locations) {

    $(config.storeGridClass).empty();
    $(config.storeCountryClass).hide();

    if (locations.length == 1) {
      var resultsCountText = config.resultCountSingle;
    } else {
      var resultsCountText = config.resultCountPlural;
    }

    $(config.resultCountEl).text(locations.length + ' ' + resultsCountText);

    if (config.sectionByCountry) {

      // sort by country
      locations.sort(function(a, b) {

        var o1 = a.addressCountry.toLowerCase();
        var o2 = b.addressCountry.toLowerCase();

        var p1 = a.title.toLowerCase();
        var p2 = b.title.toLowerCase();

        if (o1 < o2) return -1;
        if (o1 > o2) return 1;
        if (p1 < p2) return -1;
        if (p1 > p2) return 1;
        return 0;
      });

    } else {
      // sort by name
      locations.sort(function(a, b) {
        var nameA = a.title.toUpperCase(); // ignore upper and lowercase
        var nameB = b.title.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    }

    // Set current country
    var countryCode = '';

    for (var i = 0; i < locations.length; i++) {

      var store = locations[i];

      countryCode = store.addressCountry;

      var storeCardTemplate = createStoreCard(store);

      if (!config.sectionByCountry) {
        $(config.storeGridClass).append(storeCardTemplate);
      } else if (countryCode != '') {
        $('[data-country=' + countryCode + ']').show();
        $('[data-country=' + countryCode + '] ' + config.storeGridClass).append(storeCardTemplate);
      }

      countryCode = store.addressCountry;
    }

  }

  function handleLocationError(browserHasGeolocation, infoWindow, pos) {
    infoWindow.setPosition(pos);
    infoWindow.setContent(browserHasGeolocation ?
      'Error: The Geolocation service failed.' :
      'Error: Your browser doesn\'t support geolocation.');
    infoWindow.open(map);
  }


  // Click event listener on filter submit
  $('#filterSearch').on('click', function(e) {

    if (options.enableMap || options.enableFilterLocation) {
      $(config.filterLocationEl).data('lat', undefined);
      $(config.filterLocationEl).data('lng', undefined);
      $(config.filterLocationEl).attr('data-location', false);

      e.preventDefault();
      geoFilter();
    } else {

      e.preventDefault();
      textFilter()
    }
  });

  // Change event listener on radius select
  $(config.filterRadiusEl).on('change', function(e) {
    if ($(config.filterLocationEl).data('lat') != '') {
      geoFilter($(config.filterLocationEl).data('lat'), $(config.filterLocationEl).data('lng'));
    } else {
      geoFilter();
    }
  });


  // Click event listener on filter location
  $(config.filterLocationEl).on('click', function(e) {
    e.preventDefault();

    if ($(e.target).attr('data-location') == 'true') {
      $(e.target).attr('data-location', false);
      $(config.filterLocationEl).data('lat', '');
      $(config.filterLocationEl).data('lng', '');
      geoFilter();
      return;
    }

    $(config.filterAddressEl).prop('disabled', true);
    $(config.filterWrapEl).addClass('loading_location');

    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {

        $(config.filterAddressEl).val(null);

        geoFilter(position.coords.latitude, position.coords.longitude);

        $(e.target).data('lat', position.coords.latitude)
        $(e.target).data('lng', position.coords.longitude)
        $(config.filterAddressEl).prop('disabled', false);
        $(e.target).attr('data-location', true);
        $(config.filterWrapEl).removeClass('loading_location');

      }, function() {
        $(config.filterAddressEl).prop('disabled', false);
        $(e.target).attr('data-location', false);
        $(config.filterWrapEl).removeClass('loading_location');
        handleLocationError(true, infoWindow, map.getCenter());
      });
    } else {
      // Browser doesn't support Geolocation
      handleLocationError(false, infoWindow, map.getCenter());
    }
  });


  // Change event listener on text filter
  $(config.filterTextEl).on('change', function(e) {
    textFilter()
  });

  $(config.filterOnlineEl).on('change', function() {
    if ($(config.filterOnlineEl).prop('checked')) {
      $(config.filterPhysicalEl).prop('checked', false);
    }
    setTimeout(function () {
      filter();
    }, 300);
  });

  $(config.filterPhysicalEl).on('change', function() {
    if ($(config.filterPhysicalEl).prop('checked')) {
      $(config.filterOnlineEl).prop('checked', false);
    }
    setTimeout(function () {
      filter();
    }, 300);
  });

  $(config.filterCountryEl).on('change', function() {
    setTimeout(function () {
      countryFilter();
    }, 300);
  });

};


/*================ Templates ================*/
/**
 * CART
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart.
 *
 * @namespace cart
 */

theme.cart = function() {

  /*************** Variables ***************/

  var config = {
    'agreementCheckbox': '#cartAgreementCheckbox'
  };

  console.log(config.agreementCheckbox);

  // Check that the agreement checkbox is clicked
  $('body').on('click', '[name=checkout]', function(ev) {

    if ($(config.agreementCheckbox).is(':checked')) {
      $(this).submit();
    }
    else {
      alert(window.languages.cartAgreeAlert);
      return false;
    }
  });

};


$(document).ready(function() {

  // General scripts
    var sections = new slate.Sections();
    sections.register('shop-switch', theme.ShopSwitch);
    sections.register('cookie-banner', theme.CookieBanner);
    sections.register('quickbuy', theme.QuickBuy);

});
